


























import { defineComponent, computed } from '@nuxtjs/composition-api';
import AppIcon from '~/components/partials/App/AppIcon.vue';
import AppLink from '~/components/partials/App/AppLink.vue';
import { REVIEW_HASH } from '~/constants';
import { url } from '~/utils';
import { filterReviewRating } from '~/utils/modules/products';
export default defineComponent({
  components: {
    AppIcon,
    AppLink,
  },
  props: {
    score: {
      type: Number,
      required: true,
    },
    scoreColor: {
      type: Number,
      default: undefined,
    },
    count: {
      type: Number,
      required: true,
    },
    itemCode: {
      type: String,
      required: true,
    },
    isWineIntroduction: {
      type: Boolean,
      default: false,
    },
    linkDisabled: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const reviewLink = computed(() => url('ITEM_DETAIL', { code: props.itemCode }) + REVIEW_HASH);
    const fontClass = computed(() => {
      if (props.isWineIntroduction) {
        return 'text-lg font-normal';
      }
      return 'text-sm font-light';
    });

    return { filterReviewRating, reviewLink, fontClass };
  },
});
